import { HOME_PAGE, FEATUREDLIST } from "network/endpoints";
import ewbApi from "network/ewbApi";

export const fetchHomePageFeatureBanner = async () =>
  ewbApi.get(HOME_PAGE.homepageProductBanner);

export const fetchHomePageCarouselList = async () =>
  ewbApi.get(HOME_PAGE.carouselList);

export const fetchFeaturedList = async (featuredListId) =>
  ewbApi.get(`${FEATUREDLIST.list}/${featuredListId}`);

export const fetchAdvisoriesList = async () =>
  ewbApi.get(HOME_PAGE.advisoriesList);

export const fetchLatestNews = async () => ewbApi.get(HOME_PAGE.latest_news);

export const fetchQuickLins = async () => ewbApi.get(HOME_PAGE.quicklinks);
